import qs from 'qs'

import WebviewService from '@/service/webview.service'

// 웹뷰 식별 파라미터는 부트 때 최상위 쿼리에서만 읽혀, 문서를 새로 열 때 다시 붙인다
const withWebviewParams = (destinationUrl: string) => {
  const url = new URL(destinationUrl, window.location.origin)
  if (WebviewService.isAppAndroid && WebviewService.device && WebviewService.version) {
    url.searchParams.set('device', WebviewService.device)
    url.searchParams.set('version', WebviewService.version.toString())
  }
  return url.toString()
}

const LEAVE_SETTLE_MS = 10_000

const navigationUtils = {
  getPathname(pathname: string) {
    const splitted = pathname.split('?')
    return splitted[0]
  },
  reload() {
    if (WebviewService.isAppAndroid && WebviewService.device && WebviewService.version) {
      const url = new URL(window.location.href)
      url.searchParams.set('device', WebviewService.device)
      url.searchParams.set('version', WebviewService.version.toString())

      window.history.replaceState(null, '', url.toString())
    }

    return window.location.reload()
  },
  // 도착지로 문서 전체 로드(full 네비게이션) — 강제 업데이트가 최신 번들을 받으며 이동한다.
  navigate(destinationUrl: string) {
    return window.location.assign(withWebviewParams(destinationUrl))
  },
  /** 문서를 떠나는 중이다. 이때 끊긴 요청은 서버 응답이 아니다 */
  isLeavingDocument: false,
  // 지금 기록 자리를 새 문서로 바꾼다
  replaceDocument(destinationUrl: string) {
    const destination = new URL(withWebviewParams(destinationUrl))
    navigationUtils.isLeavingDocument = true
    // 떠나기 확인 창에서 머무르면 문서가 그대로 남는다. 표시를 풀어 두지 않으면 이후 이동과 POD 재발급이 막힌다
    setTimeout(() => {
      navigationUtils.isLeavingDocument = false
    }, LEAVE_SETTLE_MS)
    // 이동은 이미 주소에 반영돼 있어, 해시가 있으면 replace 가 같은 문서 안 이동으로 끝난다
    if (destination.hash && destination.href === window.location.href) {
      return window.location.reload()
    }
    return window.location.replace(destination.href)
  },
  addQueryParamsToPathname(pathname: string, newSearch: string) {
    const oldSearch = this.getSearch(pathname)
    const newQueryParams = this.upsertQueryParams(oldSearch, newSearch)
    return `${this.getPathname(pathname)}?${newQueryParams}`
  },
  upsertQueryParams(oldSearch: string, newSearch: string, opt = { addQueryPrefix: true }) {
    if (newSearch === '') return oldSearch
    if (oldSearch === '') return newSearch

    const newQueryParams = qs.parse(newSearch, { ignoreQueryPrefix: true })
    const oldQueryParams = qs.parse(oldSearch, { ignoreQueryPrefix: true })
    return qs.stringify(
      { ...oldQueryParams, ...newQueryParams },
      { addQueryPrefix: opt.addQueryPrefix },
    )
  },
  getSearch(pathname: string) {
    const splitted = pathname.split('?')
    if (splitted.length > 1) {
      return splitted[1]
    }
    return ''
  },
  isAbsoluteUrl(url: string): boolean {
    try {
      new URL(url)
      return true
    } catch (error) {
      return false
    }
  },
}

export default navigationUtils
